import type { ClaimStatus, ClaimType } from '@/lib/api-admin/types';
import type { LabelMap } from '@/lib/enumLabels';

/**
 * QA-626 클레임 목록 — 유형은 [취소] 대신 [환불]로 부른다(표시 상태가 환불신청·환불완료라 맞춘다).
 * 상태는 운영 표기(붙여 쓰기)로, 검토 중은 미사용이라 뺀다(QA-625).
 */
export const CLAIM_LIST_TYPES: ReadonlyArray<ClaimType> = ['CANCEL', 'EXCHANGE', 'RETURN'];

export const CLAIM_LIST_TYPE_LABELS: LabelMap = {
  CANCEL: '환불',
  RETURN: '반품',
  EXCHANGE: '교환',
};

export const CLAIM_LIST_STATUSES: ReadonlyArray<ClaimStatus> = [
  'REQUESTED',
  'APPROVED',
  'REJECTED',
  'COLLECTING',
  'REFUND_PENDING',
  'COMPLETED',
  'FAILED',
];

export const CLAIM_LIST_STATUS_LABELS: LabelMap = {
  REQUESTED: '신청',
  UNDER_REVIEW: '검토중',
  APPROVED: '승인',
  REJECTED: '반려',
  COLLECTING: '회수중',
  REFUND_PENDING: '환불대기',
  COMPLETED: '완료',
  FAILED: '실패',
};
